// Make it a callable function
window.initProductMediaSwipers = function (scope) {
  var $scope = scope ? $(scope) : $(document);
  
  var $mainWrapper = $scope.find('.product-main-slider .swiper-wrapper');
  var $navWrapper = $scope.find('.product-nav-slider .swiper-wrapper');
  
  if (!$mainWrapper.length || !$navWrapper.length) return;
  
  var $originalMainSlides = $mainWrapper.children().clone();
  var $originalNavSlides = $navWrapper.children().clone();
  
  var mainSlider = null;
  var navSlider = null;

  function createSwipers() {
    if (mainSlider) mainSlider.destroy();
    if (navSlider) navSlider.destroy();
    
    $scope.find('.product-main-slider, .product-nav-slider').css('height', 'auto');
    
    var isMobile = $(window).width() <= 992;
    
    navSlider = new Swiper($scope.find('.product-nav-slider')[0], {
      spaceBetween: 5,
      slidesPerView: 6,
      loop: false,
      slideToClickedSlide: true,
      freeMode: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      direction: isMobile ? 'horizontal' : 'vertical',
      speed: 400,
      observer: false,
      observeParents: false,
      resistanceRatio: 0,
      breakpoints: {
        769: {
          slidesPerView: 5,
        },
        992: {
          slidesPerView: 6,
        }
      }
    });
    
    navSlider.on('setTranslate', function (translate) {
      const maxT = navSlider.maxTranslate();
      const minT = navSlider.minTranslate();
      if (translate < minT) navSlider.setTranslate(minT);
      if (translate > maxT) navSlider.setTranslate(maxT);
    });
    
    function updateNavArrows() {
      const $next = $scope.find('.swiper-button-next');
      const $prev = $scope.find('.swiper-button-prev');
      
      $next.removeClass('swiper-button-disabled');
      $prev.removeClass('swiper-button-disabled');
    }
    navSlider.on('reachEnd reachBeginning fromEdge', updateNavArrows);
    updateNavArrows();
    
    mainSlider = new Swiper($scope.find('.product-main-slider')[0], {
      spaceBetween: 0,
      slidesPerView: 1,
      loop: false,
      speed: 400,
      navigation: {
        nextEl: $scope.find('.swiper-button-next')[0],
        prevEl: $scope.find('.swiper-button-prev')[0]
      },
      thumbs: {
        swiper: navSlider
      },
      observer: false,
      observeParents: false
    });
    
    function updateMainArrowState() {
      const $next = $scope.find('.swiper-button-next.swiper-thumb-next');
      const $prev = $scope.find('.swiper-button-prev.swiper-thumb-prev');
      
      if (mainSlider.isEnd) {
        $next.addClass('swiper-button-disabled');
      } else {
        $next.removeClass('swiper-button-disabled');
      }
      
      if (mainSlider.isBeginning) {
        $prev.addClass('swiper-button-disabled');
      } else {
        $prev.removeClass('swiper-button-disabled');
      }
    }
    mainSlider.on('slideChange', updateMainArrowState);
    mainSlider.on('afterInit', updateMainArrowState);
    updateMainArrowState();
    
    mainSlider.on('slideChange', function () {
      updateActiveCount();
    });
    
    fixSliderHeight();
    
    const navSlides = navSlider.el.querySelectorAll('.swiper-slide');
    navSlides.forEach((slideEl, idx) => {
      slideEl.addEventListener('mouseenter', function () {
        if (mainSlider && typeof mainSlider.slideTo === 'function') {
          mainSlider.slideTo(idx);
        }
        
        const visibleSlides = navSlider.slidesPerViewDynamic();
        const totalSlides = navSlider.slides.length;
        const lastVisibleIndex = navSlider.activeIndex + visibleSlides - 1;
        
        if (idx === lastVisibleIndex || idx === lastVisibleIndex - 1) {
          if (idx < totalSlides - 1) {
            navSlider.slideTo(idx - 4 < 0 ? 0 : idx - 4, 600);
          }
        } else if (idx === navSlider.activeIndex || idx === navSlider.activeIndex + 1) {
          if (idx > 0) {
            navSlider.slideTo(idx - 1, 600);
          }
        }
      });
    });
    
    const $next = $scope.find('.swiper-thumb-next');
    const $prev = $scope.find('.swiper-thumb-prev');
    
    $next.off('click.nav').on('click.nav', function () {
      if (!$next.hasClass('swiper-button-disabled')) {
        navSlider.slideNext(400);
      }
    });
    
    $prev.off('click.nav').on('click.nav', function () {
      if (!$prev.hasClass('swiper-button-disabled')) {
        navSlider.slidePrev(400);
      }
    });
    
    function toggleNavArrows() {
      var totalSlides = navSlider.slides.length;
      var slidesToShow = typeof navSlider.params.slidesPerView === 'number'
      ? navSlider.params.slidesPerView
      : 6;
      
      if (totalSlides <= slidesToShow) {
        $next.hide();
        $prev.hide();
      } else {
        $next.show();
        $prev.show();
      }
    }
    toggleNavArrows();
  }
  
  function fixSliderHeight() {
    var $imgs = $scope.find('.product-main-slider img');
    var loaded = 0;
    
    if ($imgs.length === 0) {
      $scope.find('.product-main-slider, .product-main-slider .swiper-wrapper').css('height', 'auto');
      return;
    }
    
    $imgs.each(function () {
      if (this.complete) {
        if (++loaded === $imgs.length) applyAutoHeight();
      } else {
        $(this).one('load', function () {
          if (++loaded === $imgs.length) applyAutoHeight();
        });
      }
    });
    
    function applyAutoHeight() {
      $scope.find('.product-main-slider, .product-main-slider .swiper-wrapper').css('height', 'auto');
      if (mainSlider && mainSlider.updateAutoHeight) mainSlider.updateAutoHeight();
    }
  }
  
  function updateActiveCount() {
    if (!mainSlider) return;
    
    var current = mainSlider.activeIndex + 1;
    var total = mainSlider.slides.length;
    
    var formatted = current + '/' + total;
    $scope.find('.media-slides-count .count').text(formatted);
  }

  // Load all slides directly (no filtering)
  $mainWrapper.empty().append($originalMainSlides.clone(true, true));
  $navWrapper.empty().append($originalNavSlides.clone(true, true));

  createSwipers();
  updateActiveCount();

  var resizeTimer = null;
  var lastIsMobile = $(window).width() <= 992;

  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var nowIsMobile = $(window).width() <= 992;

      if (nowIsMobile !== lastIsMobile) {
        $mainWrapper.empty().append($originalMainSlides.clone(true, true));
        $navWrapper.empty().append($originalNavSlides.clone(true, true));
        createSwipers();
        updateActiveCount();
        lastIsMobile = nowIsMobile;
      }
    }, 200);
  });

};


// Run it for normal product page
$(function () {
  window.initProductMediaSwipers(document);
});

(function () {
  const MARK_MOVED = 'jdgmMoved';  
  const MARK_BOUND = 'jdgmBound';  
  
  function moveAndBind() {
    const container = document.querySelector(
      '#judgeme_product_reviews-dek .jdgm-row-stars .jdgm-widget-actions-wrapper'
    );
    const reviewText = document.querySelector(
      '#judgeme_product_reviews-dek .jdgm-all-reviews-text'
    );
    
    // Move the element only once
    if (container && reviewText && reviewText.dataset[MARK_MOVED] !== '1') {
      container.appendChild(reviewText);
      reviewText.dataset[MARK_MOVED] = '1';
    }
    
    // Add click event only once
    const brandedLink = document.querySelector(
      '#judgeme_product_reviews-dek .jdgm-all-reviews-text--style-branded > a'
    );
    const reviewsTabWrapper =
    document.querySelector('#judgeme_product_reviews-dek .jdgm-revs-tab__wrapper') ||
    document.querySelector('.jdgm-revs-tab__wrapper');
    
    if (brandedLink && brandedLink.dataset[MARK_BOUND] !== '1') {
      brandedLink.addEventListener('click', function () {
        if (reviewsTabWrapper) reviewsTabWrapper.classList.add('jdgm-show');
        document.body.classList.add('jdgm-lock-scroll'); // << added line
      });
      brandedLink.dataset[MARK_BOUND] = '1';
    }
  }
  
  // Run at least once
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveAndBind);
  } else {
    moveAndBind();
  }
  
  // Watch for Judge.me injecting content later
  const observer = new MutationObserver(() => moveAndBind());
  observer.observe(document.body, { childList: true, subtree: true });
})();

function initVariantSlider() {
  if (window.innerWidth <= 992) {
    const slider = document.querySelector(".variant-button-selector");
    const leftArrow = document.querySelector(".variant-arrow.left");
    const rightArrow = document.querySelector(".variant-arrow.right");
    
    if (!slider || !leftArrow || !rightArrow) return;
    
    let scrollAmount = 0;
    const itemWidth = 105; // adjust to match your .variant-button width + margin
    
    // ---- check if arrows are needed ----
    const containerWidth = slider.parentElement.offsetWidth;
    if (slider.scrollWidth <= containerWidth) {
      leftArrow.style.display = "none";
      rightArrow.style.display = "none";
      return; // no scroll needed
    }
    
    // ---- arrow click logic (your original code) ----
    rightArrow.addEventListener("click", () => {
      scrollAmount -= itemWidth;
      updateTransform();
    });
    
    leftArrow.addEventListener("click", () => {
      scrollAmount += itemWidth;
      updateTransform();
    });
    
    function updateTransform() {
      const maxScroll = -(slider.scrollWidth - slider.parentElement.offsetWidth);
      
      if (scrollAmount >= 0) {
        scrollAmount = 0;
      }
      if (scrollAmount <= maxScroll) {
        scrollAmount = maxScroll;
      }
      
      slider.style.transform = `translateX(${scrollAmount}px)`;
      updateArrows(maxScroll);
    }
    
    function updateArrows(maxScroll) {
      if (scrollAmount === 0) {
        leftArrow.classList.add("disabled");
      } else {
        leftArrow.classList.remove("disabled");
      }
      
      if (scrollAmount === maxScroll) {
        rightArrow.classList.add("disabled");
      } else {
        rightArrow.classList.remove("disabled");
      }
    }
    
    // ---- touch drag logic ----
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    
    slider.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    slider.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      const deltaX = currentX - startX;
      slider.style.transform = `translateX(${scrollAmount + deltaX}px)`;
    });
    
    slider.addEventListener("touchend", (e) => {
      if (!isDragging) return;
      isDragging = false;
      
      const deltaX = e.changedTouches[0].clientX - startX;
      scrollAmount += deltaX;
      updateTransform();
    });
    
    // initialize arrow states on load
    updateTransform();
  }
}

// auto-init on DOM load
document.addEventListener("DOMContentLoaded", initVariantSlider);

const nonColorVariantOptions = document.querySelectorAll('.non-color-variant-option');
nonColorVariantOptions?.forEach(nonColorVariantOption => {
  nonColorVariantOption.addEventListener('click', () => {
    const nonColorOptionPrice = nonColorVariantOption.querySelector('.compare-price.current-sale-price').innerHTML.trim();
    const nonColorOptionDiscountedPrice = nonColorVariantOption.querySelector('.variant-sale-pricee').innerHTML.trim();
    const nonColorOptionDiscountPercent = nonColorVariantOption.querySelector('.variant-discount-label').innerHTML.trim();
    const nonClrOptionDiscountCheck = nonColorVariantOption.querySelector('.variant-discount-label').getAttribute('data-variant-discount');
    
    console.log('a',nonColorOptionPrice,'b',nonColorOptionDiscountedPrice,'c',nonClrOptionDiscountCheck);
    document.querySelector('.current-variant-discounted-price').innerHTML = nonColorOptionDiscountedPrice;
    document.querySelector('.current-variant-sale-price').innerHTML = nonColorOptionPrice;
    document.querySelector('.selected-variant-discounted-percent').innerHTML = nonColorOptionDiscountPercent;
    if(nonClrOptionDiscountCheck == '') {
      document.querySelector('.selected-variant-discounted-percent').parentElement.classList.add('hidden');
    }else{
      document.querySelector('.selected-variant-discounted-percent').parentElement.classList.remove('hidden');
    }
  })
})

const popupProtectionSummary = document.querySelector('.popup-assurance-summary');
const popupTradeShipping = document.querySelector('.popup-trade-shipping');
const popupTradeShipBtn = popupProtectionSummary.querySelector('#popup-trade-shipping-trigger');
const tradeShipBackBtn = popupTradeShipping.querySelector('.back-icon');
const popupTradePayment = document.querySelector('.popup-trade-payment');
const popupTradePaymentBtn = popupProtectionSummary.querySelector('.popup-payment-trigger');
const paymentBackBtn = popupTradePayment.querySelector('.back-icon');
const popupRefundBtn = document.querySelector('.refund-return-popup-trigger');
const popupRefundContent =  document.querySelector('.popup-refund-content');
const refundBackBtn = popupRefundContent.querySelector('.back-icon');

popupTradeShipBtn?.addEventListener('click', () => {
  popupTradeShipping.classList.remove('hidden');
  popupProtectionSummary.classList.add('hidden');
});
tradeShipBackBtn?.addEventListener('click', () => {
  popupTradeShipping.classList.add('hidden');
  popupProtectionSummary.classList.remove('hidden');
});

popupTradePaymentBtn?.addEventListener('click', () => {
  popupTradePayment.classList.remove('hidden');
  popupProtectionSummary.classList.add('hidden');
});
paymentBackBtn?.addEventListener('click', () => {
  popupTradePayment.classList.add('hidden');
  popupProtectionSummary.classList.remove('hidden');
});

popupRefundBtn?.addEventListener('click', () => {
  popupRefundContent.classList.remove('hidden');
  popupProtectionSummary.classList.add('hidden');
});
refundBackBtn?.addEventListener('click', () => {
  popupRefundContent.classList.add('hidden');
  popupProtectionSummary.classList.remove('hidden');
});

const protectionPopupOverlay = document.querySelector('.protections-popup-wrapper');
const innerContent = document.querySelector('.protections-popup-inner');

protectionPopupOverlay.addEventListener('click', function(event) {
  // Check if the clicked target is the overlay itself (not the inner content)
  if (event.target === protectionPopupOverlay) {
    protectionPopupOverlay.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden')
  }
});

// certifications sliders

var cerficationSliders = function() {
  const jkbCertSlider = new Swiper('.jkbCertSlider', {
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 300,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1300: {
        slidesPerView: 5,
        slidesPerGroup: 1,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      480: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
    },
  });

	// --- Disable arrows on start/end ---
	function updateCertArrows() {
		const prevBtn = document.querySelector('.swiper-button-prev');
		const nextBtn = document.querySelector('.swiper-button-next');

		const isLooping = jkbCertSlider.params.loop;

		// Prev button: disable only when at start & not looping
		if (!isLooping && jkbCertSlider.isBeginning) {
			prevBtn.classList.add('swiper-button-disabled');
			prevBtn.setAttribute('disabled', true);
		} else {
			prevBtn.classList.remove('swiper-button-disabled');
			prevBtn.removeAttribute('disabled');
		}

		// Next button: disable only when at end & not looping
		if (!isLooping && jkbCertSlider.isEnd) {
			nextBtn.classList.add('swiper-button-disabled');
			nextBtn.setAttribute('disabled', true);
		} else {
			nextBtn.classList.remove('swiper-button-disabled');
			nextBtn.removeAttribute('disabled');
		}
	}

	// Attach to events
	jkbCertSlider.on('afterInit slideChange update resize', updateCertArrows);

	// Run initially
	updateCertArrows();

  
  // ---------------- Popup Slider ----------------
const $popupOverlay = $('.jkbCertPopupOverlay');
const $popupSlider = $('#jkbCertPopupSlider');
const $popupSlides = $popupSlider.find('.jkb-popup-slide');
const $popupCounter = $('.jkbCertPopupCounter');

const $popupPrevBtn = $('.jkb-prev');   // ✅ Correct selector
const $popupNextBtn = $('.jkb-next');   // ✅ Correct selector

let popupIndex = 0;

window.openJkbCertPopup = function (index) {
  popupIndex = index;

  updatePopupSlider();
  $popupOverlay.css('display', 'flex');
  $('body').css('overflow', 'hidden');
};

function updatePopupSlider() {
  $popupSlider.css({
    transform: `translateX(-${popupIndex * 100}%)`,
    transition: 'transform 0.3s ease-in-out'
  });

  $popupCounter.text(`${popupIndex + 1} / ${$popupSlides.length}`);

  // Prev: hide when at first slide
  if (popupIndex === 0) {
    $popupPrevBtn.addClass('disabled').css('display', 'none');
  } else {
    $popupPrevBtn.removeClass('disabled').css('display', 'flex');
  }

  // Next: hide when at last slide
  if (popupIndex === $popupSlides.length - 1) {
    $popupNextBtn.addClass('disabled').css('display', 'none');
  } else {
    $popupNextBtn.removeClass('disabled').css('display', 'flex');
  }
}


window.closeJkbCertPopup = function () {
  $popupOverlay.css('display', 'none');
  $('body').css('overflow', 'auto');
};

// -------------------------------------------------
//  NON-LOOPING PREV / NEXT
// -------------------------------------------------
window.prevJkbCertPopupSlide = function () {
  if (popupIndex > 0) {
    popupIndex--;
  }
  updatePopupSlider();
};

window.nextJkbCertPopupSlide = function () {
  if (popupIndex < $popupSlides.length - 1) {
    popupIndex++;
  }
  updatePopupSlider();
};

// -------------------------------------------------
//  Keyboard events
// -------------------------------------------------
$(document).on('keydown', function (e) {
  if ($popupOverlay.css('display') === 'flex') {
    if (e.key === 'Escape') closeJkbCertPopup();
    else if (e.key === 'ArrowLeft') prevJkbCertPopupSlide();
    else if (e.key === 'ArrowRight') nextJkbCertPopupSlide();
  }
});

$popupOverlay.on('click', function (e) {
  if (e.target === this) closeJkbCertPopup();
});

// -------------------------------------------------
//  DRAG/SWIPE LOGIC (unchanged)
// -------------------------------------------------
let startX = 0;
let currentX = 0;
let isDragging = false;
let animationFrameId = null;

function setSliderPosition(offsetX) {
  $popupSlider.css({
    transform: `translateX(calc(-${popupIndex * 100}% + ${offsetX}px))`,
    transition: 'none'
  });
}

function animateSlider() {
  const deltaX = currentX - startX;
  setSliderPosition(deltaX);
  animationFrameId = requestAnimationFrame(animateSlider);
}

$popupSlider.on('touchstart mousedown', function (e) {
  startX = e.type === 'touchstart' ? e.originalEvent.touches[0].clientX : e.clientX;
  currentX = startX;
  isDragging = true;
  cancelAnimationFrame(animationFrameId);
  $popupSlider.css('transition', 'none');
});

$popupSlider.on('touchmove mousemove', function (e) {
  if (!isDragging) return;
  currentX = e.type === 'touchmove' ? e.originalEvent.touches[0].clientX : e.clientX;

  if (!animationFrameId) {
    animationFrameId = requestAnimationFrame(animateSlider);
  }
});

$popupSlider.on('touchend mouseup mouseleave', function () {
  if (!isDragging) return;
  isDragging = false;
  cancelAnimationFrame(animationFrameId);
  animationFrameId = null;

  const deltaX = currentX - startX;
  const threshold = 50;

  if (Math.abs(deltaX) > threshold) {
    if (deltaX > 0) {
      prevJkbCertPopupSlide();
    } else {
      nextJkbCertPopupSlide();
    }
  } else {
    updatePopupSlider();
  }
});


}

document.addEventListener("DOMContentLoaded", function () {
  cerficationSliders();
});

// prduct description toggle DESKT
var pdtDescToggling = function() {
  
  const descriptionElement = document.getElementById('product-description');
  const toggleButton = document.getElementById('toggle-description');
  const containerDesc = document.querySelector('.description-container');
  
  // Get text content WITH HTML tags preserved
  const fullHTML = descriptionElement.innerHTML.trim();
  
  // Create temporary element to count words in visible text
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = fullHTML;
  const visibleText = tempDiv.textContent || tempDiv.innerText;
  const wordsDsk = visibleText.split(/\s+/);
  
  if (wordsDsk.length > 100) {
    // Find where to cut while preserving HTML
    let charCount = 0;
    let wordCount = 0;
    let cutIndex = 0;
    
    for (let i = 0; i < wordsDsk.length; i++) {
      if (wordCount >= 100) break;
      charCount += wordsDsk[i].length + 1; // +1 for space
      wordCount++;
    }
    
    // Simple HTML-safe truncation (for demo - consider a more robust solution)
    let truncatedHTML = fullHTML;
    if (charCount < fullHTML.length) {
      truncatedHTML = fullHTML.substring(0, charCount) + '...';
    }
    
    descriptionElement.innerHTML = truncatedHTML;
    containerDesc.classList.add('collapsed');
    toggleButton.style.display = 'inline-flex';
    
    let isExpanded = false;
    const OFFSETDD = 80;
    const parentSectionDD = toggleButton.closest("#description");
    
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (isExpanded) {
        descriptionElement.innerHTML = truncatedHTML;
        containerDesc.classList.add('collapsed');
        toggleButton.querySelector('span').textContent = 'Show More';
        toggleButton.classList.remove('show-less');
        
        
        if (parentSectionDD) {
          const sectionTop = parentSectionDD.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: sectionTop - OFFSETDD,
            behavior: "smooth"
          });
        }
        
      } else {
        descriptionElement.innerHTML = fullHTML;
        containerDesc.classList.remove('collapsed');
        toggleButton.querySelector('span').textContent = 'Show Less';
        toggleButton.classList.add('show-less');
      }
      isExpanded = !isExpanded;
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  
  function toggleShippingRows(event) {
    try {
      const shippingTables = document.querySelectorAll('.data-table.shipping-table');
      const extraRows = document.querySelectorAll('.shipping-extra-row');
      
      // use event.currentTarget (the button we attached the listener to)
      const shipToggleBtn = event.currentTarget || event.target.closest('.shipping-toggle-btn');
      if (!shipToggleBtn) return;
      
      const shipToggleSvg = shipToggleBtn.querySelector('svg');
      const showMore = shipToggleBtn.querySelector('.shipping-show-more');
      const showLess = shipToggleBtn.querySelector('.shipping-show-less');
      
      // keep your original extra-rows toggle behaviour (inline style toggling)
      extraRows.forEach(row => {
        row.style.display = (row.style.display === 'none') ? 'table-row' : 'none';
      });
      
      // determine current state (use computedStyle as a safe fallback)
      const showMoreHidden = showMore && (showMore.style.display === 'none' || getComputedStyle(showMore).display === 'none');
      
      if (showMoreHidden) {
        // showMore was hidden -> show it (matches your original branch)
        if (showMore) showMore.style.display = 'inline';
        
        shippingTables.forEach(shippingTable => {
          shippingTable.classList.add('collapsed');
        });
        
        if (shipToggleSvg) shipToggleSvg.style.transform = 'rotate(0deg)';
        if (showLess) showLess.style.display = 'none';
        
        // ---- SCROLL LOGIC (applied to all .mak_shipping-table parents, safe-checks) ----
        const shipTableOffset = 80;
        const parents = document.querySelectorAll('.mak_shipping-table'); // keep exactly this selector
        if (parents.length) {
          parents.forEach(parent => {
            // only scroll to elements that are actually visible in the layout
            if (parent && parent.offsetParent !== null) {
              const sectionTopShipping = parent.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: sectionTopShipping - shipTableOffset,
                behavior: "smooth"
              });
            }
          });
        }
        // -----------------------------------------------------------------------------
        
      } else {
        // other branch (showMore visible -> hide it)
        if (showMore) showMore.style.display = 'none';
        
        shippingTables.forEach(shippingTable => {
          shippingTable.classList.remove('collapsed');
        });
        
        if (shipToggleSvg) shipToggleSvg.style.transform = 'rotate(180deg)';
        if (showLess) showLess.style.display = 'inline';
      }
      
    } catch (err) {
      // prevent script from crashing other stuff on the page
      console.error('toggleShippingRows error:', err);
    }
  }
  
  // attach handler to each button (so event.currentTarget is available)
  document.querySelectorAll('.shipping-toggle-btn').forEach(button => {
    button.addEventListener('click', toggleShippingRows);
  });
  
  document.querySelectorAll('.custom-attributes-table .extra-row td').forEach(td => {
    if (td.textContent.trim() === '') {
      td.textContent = 'N/A';
    }
  });
  
  const protectionsPopupTrigger = document.querySelector('.protections-popup-trigger');
  if(protectionsPopupTrigger){
    protectionsPopupTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('product-protections-trigger').click();
    })
  }
  
  pdtDescToggling();
  
});

document.addEventListener('DOMContentLoaded', () => {
  const buyButtonWrapper = document.querySelector('.buy-buttons-wrapper');
  const mobileStickyBar = document.querySelector('.mobile-sticky-bar');
  
  if (!buyButtonWrapper || !mobileStickyBar) return; // Ensure both elements exist

  // Function to handle scroll event
  const handleScroll = () => {
    const rect = buyButtonWrapper.getBoundingClientRect();
    
    // Check if the .buy-buttons-wrapper is out of the viewport
    if (rect.top < 0) {
      mobileStickyBar.classList.add('scrolled'); // Add scrolled class to mobile-sticky-bar
    } else {
      mobileStickyBar.classList.remove('scrolled'); // Remove scrolled class when .buy-buttons-wrapper comes into view
    }
  };

  // Listen for scroll events
  window.addEventListener('scroll', handleScroll);

  // Initial check in case the page is already scrolled
  handleScroll();
});


document.addEventListener("DOMContentLoaded", function () {

  const productNavTabs = function () {
    const menuLinks = document.querySelectorAll(".custom-menu-items a");
    const offset = 100; // Adjust for sticky header

    menuLinks.forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href").slice(1);
        const targetEl = document.getElementById(targetId);

        if (targetEl) {
          // Find if we're inside a popup (adjust selector to your popup container)
          const popup = this.closest("quick-add-modal");

          if (popup) {
            // scroll inside popup
            const popupScrollContainer = popup.querySelector(".quick-add-modal__content");
            if (popupScrollContainer) {
              const targetPosition = targetEl.offsetTop - offset;
              popupScrollContainer.scrollTo({
                top: targetPosition,
                behavior: "smooth"
              });
            }
          } else {
            // scroll the window (default collection/product page case)
            const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({
              top: targetPosition,
              behavior: "smooth"
            });
          }

          // manage active state
          document.querySelectorAll(".custom-item").forEach(item => item.classList.remove("custom-active"));
          this.parentElement.classList.add("custom-active");
        }
      });
    });
  }

  productNavTabs();

});

// Pause main YouTube video when Fancybox opens
document.addEventListener('DOMContentLoaded', function () {
  $('[data-fancybox="pro-img"]').on('click', function () {
    // Get all YouTube iframes on page
    const iframes = document.querySelectorAll('.js-youtube');

    iframes.forEach(iframe => {
      // Use YouTube API "postMessage" to pause video
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
  });

  // Function to append product form to the sticky bar
function appendProductForm() {
  const productFromStickyData = $('product-form').prop('outerHTML');
  $('#productStickyBar').html(productFromStickyData);
}

// Check if sealapps-bis-widget exists on the page
const sealappsBisWidget = document.getElementById('sealapps-bis-widget');

if (sealappsBisWidget) {
  // If widget exists, use MutationObserver
  const sealappsObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.classList && node.classList.contains('product-restore-email')) {
            appendProductForm();
            sealappsObserver.disconnect(); // Run once
          }
        });
      }
    });
  });

  // Start observing widget
  sealappsObserver.observe(sealappsBisWidget, {
    childList: true,
    subtree: true,
  });

} else {
  // If widget does NOT exist → product is in stock → append immediately
  appendProductForm();
}


  
  // 2️⃣ Fix duplicate IDs inside sticky form
  $('#productStickyBar [id]').each(function() {
    const oldId = $(this).attr('id');
    const newId = oldId + '-sticky';
    $(this).attr('id', newId);
    $('#productStickyBar [for="' + oldId + '"]').attr('for', newId);
  });

  // 3️⃣ Get references
  const $mainQty = $('product-form:first .quantity__input');      // original form quantity
  const $stickyQty = $('#productStickyBar .quantity__input');     // sticky form quantity
  const $mainAddToCart = $('product-form:first .primary-atc-button'); // original form add to cart button
  const $stickyAddToCart = $('#productStickyBar .primary-atc-button'); // sticky button
  const $mainBuyNowBtn = $('product-form:first .product-buy-now-btn');
  const $stickyBuyBtn = $('#productStickyBar').find('.product-buy-now-btn');
  $stickyBuyBtn.removeAttr('onclick');

  // Add a click event listener on the button inside the sticky bar
  $stickyBuyBtn.on('click', function(e) {
    e.preventDefault();
    console.log('button clicked')
    $mainBuyNowBtn.click();
  });


  // 4️⃣ Sync sticky qty to main qty
  $stickyQty.on('input change', function() {
    const val = $(this).val();
    $mainQty.val(val).attr('value', val).trigger('change'); // update original
  });

  // 5️⃣ Optional: sync main qty back to sticky if changed elsewhere
  $mainQty.on('input change', function() {
    const val = $(this).val();
    $stickyQty.val(val).attr('value', val);
  });

  // 6️⃣ Sticky add to cart triggers original add to cart
  $stickyAddToCart.on('click', function(e) {
    e.preventDefault();              // prevent sticky form submission
    $mainAddToCart.trigger('click'); // trigger original button
  });

  const pdpsectionmenu = document.querySelector('.custom-menu-items');
    let pdpSectionMenuIsDown = false;
    let pdpSectionMenuStartX;
    let pdpSectionMenuScrollLeft;

    // Mouse Events
    pdpsectionmenu.addEventListener('mousedown', (e) => {
      pdpSectionMenuIsDown = true;
      pdpsectionmenu.classList.add('active');
      pdpSectionMenuStartX = e.pageX - pdpsectionmenu.offsetLeft;
      pdpSectionMenuScrollLeft = pdpsectionmenu.scrollLeft;
    });
    pdpsectionmenu.addEventListener('mouseleave', () => (pdpSectionMenuIsDown = false));
    pdpsectionmenu.addEventListener('mouseup', () => (pdpSectionMenuIsDown = false));
    pdpsectionmenu.addEventListener('mousemove', (e) => {
      if (!pdpSectionMenuIsDown) return;
      e.preventDefault();
      const x = e.pageX - pdpsectionmenu.offsetLeft;
      const pdpSectionMenuWalk = (x - pdpSectionMenuStartX) * 1.5; // adjust scroll speed
      pdpsectionmenu.scrollLeft = pdpSectionMenuScrollLeft - pdpSectionMenuWalk;
    });

    // Touch Events (for mobile)
    pdpsectionmenu.addEventListener('touchstart', (e) => {
      pdpSectionMenuIsDown = true;
      pdpSectionMenuStartX = e.touches[0].pageX - pdpsectionmenu.offsetLeft;
      pdpSectionMenuScrollLeft = pdpsectionmenu.scrollLeft;
    });
    pdpsectionmenu.addEventListener('touchend', () => (pdpSectionMenuIsDown = false));
    pdpsectionmenu.addEventListener('touchmove', (e) => {
      if (!pdpSectionMenuIsDown) return;
      const x = e.touches[0].pageX - pdpsectionmenu.offsetLeft;
      const pdpSectionMenuWalk = (x - pdpSectionMenuStartX) * 1.5;
      pdpsectionmenu.scrollLeft = pdpSectionMenuScrollLeft - pdpSectionMenuWalk;
    });


});



 // Thumbnail slider (loop disabled)
  const amazon_thumbSlider = new Swiper(".amazon-aplus-thumbs-slider", {
    slidesPerView: 8,
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      0: { slidesPerView: 3 },
      500: { slidesPerView: 4 },
      992: { slidesPerView: 8 }
    }
  });

  // Main slider (loop disabled)
  const amazon_mainSlider = new Swiper(".amazon-aplus-main-slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: amazon_thumbSlider, // auto-sync thumbnails
    },
  });

  // Auto-scroll thumbnail slider on main slider change
  amazon_mainSlider.on("slideChange", () => {
  const mainRealIndex = amazon_mainSlider.realIndex;
  const thumbsVisible = amazon_thumbSlider.params.slidesPerView;
  const totalThumbs = amazon_thumbSlider.slides.length;

  // Calculate the index to scroll thumbnail slider
  let scrollToIndex = mainRealIndex - Math.floor(thumbsVisible / 2);

  // Clamp the scroll index so it doesn't go negative or beyond max
  scrollToIndex = Math.max(0, Math.min(scrollToIndex, totalThumbs - thumbsVisible));

  amazon_thumbSlider.slideTo(scrollToIndex);
});



// Toggle Show and Less the key attributes
function toggleAccordion(header) {
    header.classList.toggle("active");
    const content = header.nextElementSibling;
    if (header.classList.contains("active")) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = null;
    }
  }
  
  function toggleRows(button) {
    const table = button.previousElementSibling;
    const extraRows = table.querySelectorAll('.extra-row');
    const buttonSvg = button.querySelector('svg');
    const showMore = button.querySelector('.mak-show-more');
    const showLess = button.querySelector('.mak-show-less');
    const attributesParent = button.closest('#attributes');
    const offsetAttribute = 80;
    console.log('att',attributesParent);  
    const isHidden = extraRows[0].classList.contains('hidden-row');
    
    extraRows.forEach(row => {
      row.classList.toggle('hidden-row');
      row.classList.toggle('slide');
    });
    
    if (isHidden) {
      showMore.style.display = 'none';
      table.classList.remove('collapsed');
      buttonSvg.style.transform = 'rotate(180deg)';
      showLess.style.display = 'inline';
    } else {
      showMore.style.display = 'inline';
      table.classList.add('collapsed');
      buttonSvg.style.transform = 'rotate(0deg)';
      showLess.style.display = 'none';
      
      
      if (attributesParent) {
        const attributesectionTop = attributesParent.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: attributesectionTop - offsetAttribute,
          behavior: "smooth"
        });
      }
      
    }
  }






document.addEventListener('DOMContentLoaded', function () {
  var iframes = document.querySelectorAll('iframe.js-product-video, iframe.iframe-video-snippet');  // Select both iframes

  if (!iframes.length) return;

  // Function to load iframe and make it autoplay + mute
  function loadIframe(iframe) {
    if (!iframe.dataset.src || iframe.src === iframe.dataset.src) return;
    iframe.src = iframe.dataset.src; // Lazy-load the video
    iframe.dataset.src = ''; // Clear data-src to prevent future loads
  }

  // Check if IntersectionObserver is supported
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadIframe(entry.target);
          obs.unobserve(entry.target); // Stop observing after loading
        }
      });
    }, {
      root: null,
      threshold: 0.3 // 50% of iframe must be in view to autoplay
    });

    iframes.forEach(function (iframe) {
      observer.observe(iframe);
    });
  } else {
    // Fallback: Check on scroll for older browsers
    function onScroll() {
      iframes.forEach(function (iframe) {
        if (!iframe.dataset.src) return;
        var rect = iframe.getBoundingClientRect();
        var inView = rect.top < window.innerHeight * 0.7 && rect.bottom > 0;
        if (inView) loadIframe(iframe);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll(); // Initial check on page load
  }

  const videoWrapper = document.querySelector('.video-snippet-iframe');
  if (!videoWrapper) return;

  const playButton = videoWrapper.querySelector('.video-section__poster');
  if (!playButton) return;

  let hasPlayed = false; // prevent replaying on scroll up/down

  // Create observer
  const last_observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasPlayed) {
        hasPlayed = true;

        // click the play button to start video
        playButton.click();

        // stop observing once triggered
        last_observer.unobserve(videoWrapper);
      }
    });
  }, {
    threshold: 0.3 // Adjust: fires when 50% of element shows
  });

  last_observer.observe(videoWrapper);

});


